import { useRef, useState } from "react";
import useDialog from "../../../../hooks/useDialog"
import { getProductDetail } from "../../../../http/api/ProductDetailAPI";
import { inputValueToInt } from "../../../../utils/utils";

export const useAddProductDialogs = () => {
  const addProductDialog = useDialog();
  const addProductMasterDialog = useDialog();
  const addProductDetailMasterDialog = useDialog();

  const [addingProduct, setAddingProduct] = useState({});

  const onAddProductRef = useRef(null);

  /**
   * 商品追加ダイアログを開く
   * @param onAddProduct 商品追加時挙動
   */
  const openAddProductDialog = async (onAddProduct) => {

    if (onAddProduct) {
      onAddProductRef.current = onAddProduct;
    }

    const addProductResult = await addProductDialog.open();

    if (!addProductResult) {
      setAddingProduct({});
      return; 
    }

    const product = addProductResult.product;

    if (addProductResult.status == "SUBMITTED") {

      const productRes = await getProductDetail({
        productId: product.addingProduct.productId,
        productDetailId: product.addingProduct.productDetailId
      });

      const productDetailInfo = productRes.listProductDetailInfo[0];

      onAddProductRef.current({
        ...productDetailInfo,
        originName: productDetailInfo.origin,
        rankName: productDetailInfo.rank,
        productClassName: productDetailInfo.productClass,
        packingName: productDetailInfo.packing,
        weightUnitName: productDetailInfo.weightUnit,
        orderingUnitName: productDetailInfo.orderingUnit,
        orderingUnitQuantity: productDetailInfo.quantity,
        orderPrice: inputValueToInt(product.addingProduct.price),      
        orderTypeId: product.tabPos,
      });

      setAddingProduct({});
    }

    if (addProductResult.status == "ADD_PRODUCT_MASTER") {
      setAddingProduct(product);
      await openAddProductMasterDialog();
    }
    if (addProductResult.status == "ADD_PRODUCT_DETAIL_MASTER") {
      setAddingProduct(product);
      await openAddProductDetailMasterDialog();
    }
  }

  /**
   * 商品マスタ追加ダイアログを開く
   */
  const openAddProductMasterDialog = async () => {
    const addProductMasterResult = await addProductMasterDialog.open();
    if (!addProductMasterResult) { return; }

    const addingProduct = addProductMasterResult.product;

    if (addProductMasterResult.status == "ADD_PRODUCT_DETAIL_MASTER") {
      setAddingProduct(addingProduct);
      await openAddProductDetailMasterDialog();
    }
    if (addProductMasterResult.status == "RETURN_ADD_PRODUCT") {
      await openAddProductDialog();
    }
  }

  /**
   * 商品明細マスタ追加ダイアログを開く
   */
  const openAddProductDetailMasterDialog = async () => {
    const addProductDetailMasterResult = await addProductDetailMasterDialog.open();
    if (!addProductDetailMasterResult) { return; }

    const addingProduct = addProductDetailMasterResult.product;

    if (addProductDetailMasterResult.status == "REOPEN_ADD_PRODUCT") {
      setAddingProduct(addingProduct);
    }
    await openAddProductDialog();
  }

  return ({
    addingProduct,
    openAddProductDialog,
    addProductDialog,
    addProductMasterDialog,
    addProductDetailMasterDialog
  });
  



}